import React from 'react';
import {Grid} from '@material-ui/core';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import FormikPriceInput from 'gui/components/formikPriceInput/FormikPriceInput';
import EditorSection from '../../../editorSection';
import {generateAdditionalInfo} from 'gui/components/formikDescription';
import {IConditionDetails} from 'data/interfaces/products';


const Conditions = (props: { values: IConditionDetails }) => {
  return (
    <EditorSection title="עלות שינוי - עלות שינוי השם בהזמנה">
      <Grid item xs={12} sm={6} md={6}>
        <MDBPopover
          placement="top"
          popover
          clickable
          domElement={true}
        >
          <div>
            <FormikPriceInput
              label='ס"הכ עלות שינוי'
              name="changePrice"
              currency={props.values.currency}
              noBorder
            />
          </div>
          <div>
            <MDBPopoverBody>
              *דימי השינוי ישולמו ע"י המוכר. אם אין עלות שינוי יש למלא את הספרה 0
            </MDBPopoverBody>
          </div>
        </MDBPopover>
        {generateAdditionalInfo([
          '*דימי השינוי ישולמו ע"י המוכר. אם אין עלות שינוי יש למלא את הספרה 0'
        ])}
      </Grid>
      <Grid item xs={12} sm={6} md={6}>

      </Grid>
    </EditorSection>
  );
};

Conditions.defaultProps = {
  values: {},
};

export default React.memo(Conditions);
